import { useQuery } from 'react-query';
import queryString from 'query-string';

import { axiosInstance } from '@shared/lib/axios';
import type { TUser, TUserFilters } from '@entities/user/lib/types';
import type { TAxiosError, TAxiosPaginatedResponse, TAxiosResponseTransformedData, TPagination } from '@shared/lib';
import { QUERIES_INFO } from '@shared/lib';
import { prepareFilters, preparePagination } from '@shared/lib/helpers';

export const useGetUsers = (filters: TUserFilters, pagination: TPagination) =>
  useQuery<TAxiosPaginatedResponse<TUser[]>, TAxiosError, TAxiosResponseTransformedData<TUser[]>>(
    [QUERIES_INFO.adminUsers.key, filters.name, filters.email, pagination.limit, pagination.offset],
    () => {
      const preparedPagination = preparePagination(pagination);
      const preparedFilters = prepareFilters(filters);

      return axiosInstance.get(
        `${QUERIES_INFO.adminUsers.endpoint}?${queryString.stringify(
          { ...preparedFilters, ...preparedPagination },
          {
            skipEmptyString: true,
            arrayFormat: 'bracket',
          },
        )}`,
      );
    },
    { select: (paginatedResponse) => paginatedResponse.data, keepPreviousData: true },
  );
